<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">
      <div class="row">
        <div v-if="isReportReader" class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Instansi / OPD</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.companyId"
                :options="listCompanies"
                :reduce="item => item.ID"
                placeholder="Instansi / OPD"
                @input="onRefresh"
                label="Name"/>
            </div>
          </div>
        </div>
        <div v-if="isReportReader" class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tipe Pegawai</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.employeeTypeId"
                :options="listEmployeeTypes"
                :reduce="item => item.ID"
                placeholder="Tipe Pegawai"
                @input="onRefresh"
                label="Name"/>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tanggal</label>
            <div class="col-sm-8">
              <b-form-datepicker v-model="filter.date" @input="onRefresh" locale="id"></b-form-datepicker>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Pegawai</label>
            <div class="col-sm-8">
              <input
                class="form-control form-control-sm"
                v-model.lazy="filter.name"
                placeholder="Cari Pegawai"
                @keyup.enter="onRefresh" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrint" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>
          <!-- 
          <button class="btn btn-sm btn-success btn-icon-split text-dark" @click="exportToExcel" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Excel <b-spinner small v-show="isLoading" /></span>
          </button>
           -->
        </div>
      </div>
    </div>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="filter"
      :search="search"
      @onSelectItem="selectedItem = $event">

      <template #caption>
        <span class="table-cap bg-secondary p-1 mr-2 text-light"><strong>ASW</strong>: Absen Sebelum Waktu</span>
        <span class="table-cap bg-danger p-1 mr-2 text-light"><strong>TL</strong>: Terlambat</span>
        <span class="table-cap bg-warning p-1"><strong>PSW</strong>: Pulang Sebelum Waktu</span>
        <span class="table-cap bg-secondary p-1 mr-2 text-light"><strong>AMW</strong>: Absen Melebihi Waktu</span>
      </template>

    </AppTable>

    <b-modal id="modalPrint" hide-footer no-close-on-backdrop size="xl" title="Cetak Presensi Pegawai" header-class="bg-light text-primary py-1">

      <iframe ref="printFrame" id="printFrame" class="w-100" height="600" name="printFrame"></iframe>

      <div class="text-center">
        <button class="btn btn-primary" @click="printToPDF">Print</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppTable },
  mounted() {
    this.onRefresh()

    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/attendance-daily-report',
      tableFields: [
        { key: 'index', label: 'No.', class: 'column-width-20' },
        { key: 'EmployeeIdNumber', label: 'NIP' },
        { key: 'Name', label: 'Nama', class: 'column-name-width' },
        { key: 'Capture', label: 'Tanggal', formatter: value => `${this.$helper.formatDate(value)}` },
        { key: 'StartTime', label: 'Jam Masuk' },
        { key: 'EndTime', label: 'Jam Keluar' },
        { key: 'IgnoreStatus', label: 'ASW', variant: 'secondary', formatter: value => {
          if (value === 1) {
            return `<span class="badge badge-danger">${this.$helper.boleanText(value)}</span>` 
          } else {
            return `<span class="badge badge-success">${this.$helper.boleanText(value)}</span>` 
          }
        }},
        { key: 'LateStatus', label: 'TL', variant: 'danger', formatter: value => {
          if (value === 1) {
            return `<span class="badge badge-danger">${this.$helper.boleanText(value)}</span>` 
          } else {
            return `<span class="badge badge-success">${this.$helper.boleanText(value)}</span>` 
          }
        }},
        { key: 'EarlierStatus', label: 'PSW', variant: 'warning' , formatter: value => {
          if (value === 1) {
            return `<span class="badge badge-danger">${this.$helper.boleanText(value)}</span>` 
          } else {
            return `<span class="badge badge-success">${this.$helper.boleanText(value)}</span>` 
          }
        }},
        { key: 'AfterStatus', label: 'AMW', variant: 'secondary', formatter: value => {
          if (value === 1) {
            return `<span class="badge badge-danger">${this.$helper.boleanText(value)}</span>` 
          } else {
            return `<span class="badge badge-success">${this.$helper.boleanText(value)}</span>` 
          }
        }},
        { key: 'AttendanceUserID', label: 'ID Absensi', formatter: value => (value) ? value : `<span class="badge badge-danger">Belum ditentukan</span>` },
      ],
      selectedItem: null,
      search: '',
      filter: {
        companyId: JSON.parse(localStorage.getItem('userData')).employee.CompanyID,
        employeeTypeId: '',
        date: this.$helper.dateToYMD((new Date())),
        name: ''
      },
      listCompanies: [],
      listEmployeeTypes: [],
      // listWeeklyScheduleCategories: []
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    isReportReader () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 1 || item.ID === 5 || item.ID === 4 || item.ID === 7))
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },

    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/company'),
        this.$axios.get('/employee-type'),
      ]).then(this.$axios.spread((...res) => {
        this.listCompanies = res[0].data
        this.listEmployeeTypes = res[1].data
      }))
    },
    onPrint () {
      this.$bvModal.show('modalPrint')

      this.generateReport().then(data => {

        this.$nextTick(function () {
          this.$refs.printFrame.srcdoc = data
        })
      })
    },

    generateReport () {
      const params = this.filter

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <h2 class="text-center">REKAP PRESENSI PEGAWAI</h2>
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined">Tanggal ${this.$helper.formatDate(this.filter.date)}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>NIP</th>
            <th>Nama</th>
            <th>ID Absensi</th>
            <th>Jam Masuk</th>
            <th>Jam Keluar</th>
            <th>ASW</th>
            <th>TL</th>
            <th>PSW</th>
            <th>AMW</th>
          </tr>
        `

        let totalIgnoreStatus = 0
        let totalLateStatus = 0
        let totalEarlierStatus = 0
        let totalAfterStatus = 0

        const rows = res.data.rows

        let content = ''
        for (var i = 0; i < rows.length; i++) {
          content += `
            <tr>
              <td>${i+1}</td>
              <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
              <td>${rows[i].Name}</td>
              <td>${rows[i].AttendanceUserID}</td>
              <td>${rows[i].StartTime}</td>
              <td>${rows[i].EndTime}</td>
              <td>${this.$helper.boleanText(rows[i].IgnoreStatus)}</td>
              <td>${this.$helper.boleanText(rows[i].LateStatus)}</td>
              <td>${this.$helper.boleanText(rows[i].EarlierStatus)}</td>
              <td>${this.$helper.boleanText(rows[i].AfterStatus)}</td>
            </tr>
          `

          if (rows[i].LateStatus === 1) {
            totalLateStatus += 1
          }

          if (rows[i].EarlierStatus === 1) {
            totalEarlierStatus += 1
          }

          if (rows[i].IgnoreStatus === 1) {
            totalIgnoreStatus += 1
          }

          if (rows[i].AfterStatus === 1) {
            totalAfterStatus += 1
          }
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="6">TOTAL</td>
            <td>${totalIgnoreStatus}</td>
            <td>${totalLateStatus}</td>
            <td>${totalEarlierStatus}</td>
            <td>${totalAfterStatus}</td>
          </tr>
        `

        const foot = `
          </table>

          <br><br>
          <div>
            <strong>Keterangan:</strong><br>
            ASW: Absen Sebelum Waktu <br>
            TL: Terlambat <br>
            PSW: Pulang Sebelum Waktu <br>
            AMW: Absen Melebihi Waktu
          </div>
        `

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    printToPDF () {
      window.frames['printFrame'].print()
    },

    exportToExcel (e) {
      const elem = e.currentTarget

      if (!elem.getAttribute('download')) {
        this.generateReport().then(data => {

          let excelContent = data

          const fileName = `presensi-pegawai.xls`

          excelContent = excelContent.replace(/<A[^>]*>|<\/A>/g, '')//remove if u want links in your table
          excelContent = excelContent.replace(/<img[^>]*>/gi,'') // remove if u want images in your table
          excelContent = excelContent.replace(/<input[^>]*>|<\/input>/gi, '') // reomves input params

          const ua = window.navigator.userAgent
          const msie = ua.indexOf('MSIE ')

          // If Internet Explorer
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            txtArea1.document.open('txt/html','replace')
            txtArea1.document.write(excelContent)
            txtArea1.document.close()
            txtArea1.focus() 
            
            txtArea1.document.execCommand('SaveAs', true, fileName)
          }  
          else {
            const url = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(excelContent))  
            // const url = 'data:application/vnd.ms-excel,' + escape(excelContent)
            // elem.setAttribute('href', url)
            // elem.setAttribute('download', fileName)

            // elem.click()

            return false
          }
        })

      }

      return false
    }
  }
}
</script>

<style scoped>
  .table-cap {
    font-size: 0.8rem;
    border-radius: 5px;
  }
</style>
